import { gql } from '@apollo/client';

export const CREATE_LEAD = gql`
  mutation CreateLead(
    $email: String!
    $name: String!
    $phone: String!
    $courseSlug: String!
    $courseTitle: String!
    $newsletter: Boolean!
    $status: String!
  ) {
    attachCourseToEmail(
      email: $email
      name: $name
      phone: $phone
      courseSlug: $courseSlug
      courseTitle: $courseTitle
      newsletter: $newsletter
      status: $status
    ) {
      course {
        data {
          id
        }
      }
      lead {
        data {
          id
        }
      }
    }
  }
`;

export const UPDATE_SUBSCRIPTION = gql`
  mutation UpdateCurrentSubscription($leadId: Int!, $courseId: Int!, $status: String!) {
    updateCurrentSubscription(leadId: $leadId, courseId: $courseId, status: $status) {
      status
    }
  }
`;
